import { render, staticRenderFns } from "./VersionBadge.vue?vue&type=template&id=44358312&scoped=true"
import script from "./VersionBadge.vue?vue&type=script&lang=js"
export * from "./VersionBadge.vue?vue&type=script&lang=js"
import style0 from "./VersionBadge.vue?vue&type=style&index=0&id=44358312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44358312",
  null
  
)

export default component.exports